/**
 * Generato automaticamente.
 * framework-cmp-procedimenti
 */
import { useQuery } from 'react-query';
import type {
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryResult,
} from 'react-query';
import { apiClientRequest } from '../../../client/apiClient';
import type { ErrorType } from '../../../client/apiClient';
import type { DataOption, GetBackUtentiParams } from '.././schemas';

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

// eslint-disable-next-line
type SecondParameter<T extends (...args: any) => any> = T extends (
  config: any,
  args: infer P,
) => any
  ? P
  : never;

/**
 * cerca una serie di utenti che effettuano le lavorazioni
 * @summary Utenti [search]
 */
export const getBackUtenti = (
  params: GetBackUtentiParams,
  options?: SecondParameter<typeof apiClientRequest>,
  signal?: AbortSignal,
) => {
  return apiClientRequest<DataOption[]>(
    { url: `/framework-bo-procedimenti/utenti`, method: 'get', params, signal },
    options,
  );
};

export const getGetBackUtentiQueryKey = (params: GetBackUtentiParams) =>
  [`/framework-bo-procedimenti/utenti`, ...(params ? [params] : [])] as const;

export const getGetBackUtentiQueryOptions = <
  TData = Awaited<ReturnType<typeof getBackUtenti>>,
  TError = ErrorType<unknown>,
>(
  params: GetBackUtentiParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getBackUtenti>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryOptions<Awaited<ReturnType<typeof getBackUtenti>>, TError, TData> & {
  queryKey: QueryKey;
} => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetBackUtentiQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getBackUtenti>>> = ({
    signal,
  }) => getBackUtenti(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions };
};

export type GetBackUtentiQueryResult = NonNullable<
  Awaited<ReturnType<typeof getBackUtenti>>
>;
export type GetBackUtentiQueryError = ErrorType<unknown>;

/**
 * @summary Utenti [search]
 */
export const useGetBackUtenti = <
  TData = Awaited<ReturnType<typeof getBackUtenti>>,
  TError = ErrorType<unknown>,
>(
  params: GetBackUtentiParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getBackUtenti>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetBackUtentiQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};
